import isError from 'lodash/isError';
import attempt from 'lodash/attempt';
export function isJSON(str: string) {
  return !isError(attempt(JSON.parse, str));
}
